export default "__VITE_ASSET__Bv3lumYq__"